import React from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import ActiveReportSummary from "./ActiveReportSummary";
import ActiveToolboxSummary from "./ActiveToolboxSummary";
import DashboardTabs from "./DashboardTabs";

const ClientDashboard = () => {
  document.title = "LTA Admin Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Dashboard" pageTitle="Dashboard" />
          <DashboardTabs>
            {/* <Row className="project-wrapper">
                          <Col xxl={8}>
                              <EmployeeWidgets />
                          </Col>
                      </Row> */}
            <Row>
              <ActiveReportSummary />
              <ActiveToolboxSummary />

              {/* <ActiveProjects /> */}
              {/* <TeamMembers /> */}
            </Row>
          </DashboardTabs>
          {/* <Row>
                        <TeamMembers />
                        <PermitDashboard />
                        <Chat />
                         <MyTasks />
                        <ProjectsStatus />
                    </Row> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ClientDashboard;
